import { get, post, del } from "../client";
import {
  GET_SCHEDULE_OVERRIDES,
  CREATE_SCHEDULE_OVERRIDE,
  CREATE_SCHEDULE_OVERRIDE_RANGE,
  DELETE_SCHEDULE_OVERRIDE,
  CHECK_SCHEDULE_OVERRIDE_CONFLICTS,
} from "../routes";

const SCHEDULE_OVERRIDE = {
  getAll: async (employeeId) => await get(GET_SCHEDULE_OVERRIDES(employeeId)),

  create: async (data) => await post(CREATE_SCHEDULE_OVERRIDE, data),

  createRange: async (data) => await post(CREATE_SCHEDULE_OVERRIDE_RANGE, data),

  remove: async (id) => await del(DELETE_SCHEDULE_OVERRIDE(id)),

  checkConflicts: async (data) => await post(CHECK_SCHEDULE_OVERRIDE_CONFLICTS, data),
};

export default SCHEDULE_OVERRIDE;
